module.exports = __webpack_public_path__ + "static/media/linkedin.78c1a2d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Follow/linkedin.svg
// module id = 625
// module chunks = 0